import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Stack, StackProps, Typography, TypographyProps } from '@mui/material';

import { useFormatPercent } from '@arrived/hooks';

interface CalculatorCardStatProps extends StackProps {
  label: string | ReactNode;
  labelTypography?: TypographyProps;
  percentage: number;
  PercentTypographyProps?: TypographyProps;
}

export const CalculatorCardStat = ({
  label,
  percentage,
  labelTypography,
  PercentTypographyProps,
  ...rest
}: CalculatorCardStatProps) => {
  const formatPercent = useFormatPercent();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      gap={1}
      flexWrap="nowrap"
      width="100%"
      {...rest}
    >
      <Typography textAlign="left" sx={{ flex: '1 1 auto' }} {...labelTypography}>
        {label}
      </Typography>
      <Stack direction="row" alignItems="center" gap={0.5}>
        <Typography component="span" {...PercentTypographyProps}>
          {formatPercent(percentage)}
        </Typography>
        <span>{'/'}</span>
        <Typography component="span">
          <FormattedMessage id="year" defaultMessage="Year" />
        </Typography>
      </Stack>
    </Stack>
  );
};
